// extracted by mini-css-extract-plugin
module.exports = {"cards":"style_cards__tCsJ_","skeleton":"style_skeleton___v96I","ice":"style_ice__jV8ud"};